import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { catalogApi, type Catalog, type CategoryNode } from '../../api/catalog';
import { CategoryTreeView } from './CategoryTreeView';

export function CategoryTreePage() {
  const [catalogs, setCatalogs] = useState<Catalog[]>([]);
  const [catalogId, setCatalogId] = useState('');
  const [tree, setTree] = useState<CategoryNode[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    void catalogApi
      .listCatalogs()
      .then((items) => {
        setCatalogs(items);
        if (items[0]?.id) setCatalogId(items[0].id);
      })
      .catch((e) => setError(String(e)));
  }, []);

  useEffect(() => {
    if (!catalogId) return;
    setLoading(true);
    void catalogApi
      .getCategoryTree(catalogId)
      .then(setTree)
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false));
  }, [catalogId]);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/catalog" className="text-sm text-slate-600 hover:underline">← Catalogs</Link>
      <h1 className="mt-4 text-2xl font-semibold">Category Tree</h1>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <label className="text-sm text-slate-600">
          Catalog
          <select
            value={catalogId}
            onChange={(e) => setCatalogId(e.target.value)}
            className="ml-2 rounded-lg border px-3 py-2 text-sm"
          >
            {catalogs.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </label>
        <Link to="/catalog/categories/new" className="text-sm text-slate-700 hover:underline">Add category</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 rounded-xl border bg-white p-4">
        {loading ? <p>Loading tree…</p> : tree.length ? <CategoryTreeView nodes={tree} /> : <p className="text-slate-500">No categories in this catalog.</p>}
      </div>
    </div>
  );
}
